import styled from '@emotion/styled';

export const Footer = styled.footer`
  height: 96px;
  background: rgba(245, 247, 248, 0.6);
`;

export const FooterContent = styled.div`
  margin: 14px 26px 0px 26px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: #78909c;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.21;
`;
